import Platform from './Platform'
import App from '../App'
import {ENUM_IV} from "../../common/enums";

class Android extends Platform {
  constructor() {
    super()
  }

  // iOS 下禁用页面滑动反弹
  toggleBouncesOff() {
    console.warn('安卓不支持bounces off')
  }

  // iOS 下启用页面滑动反弹
  toggleBouncesOn() {
    console.warn('安卓不支持bounces on')
  }

  /**
    * 预加载storeKit
    * @param params
    * @returns {*|Promise<any>}
    */
  preloadStoreKit (params = {}) {
    console.warn('安卓不支持preloadStoreKit')
  }

  /**
  * 添加stk到父视图
  * @param params
  * @returns {*|Promise<any>}
  */
  addStoreKitTo (params = {}) {
    console.warn('安卓不支持addStoreKitTo')
  }

  /**
   * 为increaseOfferFrequenceForRvIv接口组成要发送的数据
   * @param campaign {Object}
   */
  prepareDataForIncOfferFreRvIv(campaign = {}) {
    const dataSend = {
      data: {
        unitId: App.unit.id,
        id: campaign.id,
        fcb: campaign.fcb,
        fca: campaign.fca,
        only_impression_url: campaign.only_impression_url,
      }
    }
    return dataSend
  }

  getIvRewardEnable() {
    let ivreward = this.getIvreward()
    return ivreward.ivRewardEnable
  }

  getIvRewardPlayValue () {
    console.log('Platform: Android: getIvRewardPlayValue')
    let ivreward = this.getIvreward()
    let ivRewardPlayValueMode = ivreward.ivRewardPlayValueMode
    let ivRewardPlayValue = ivreward.ivRewardPlayValue
    if(ivRewardPlayValueMode === ENUM_IV.IV_REWARD_PLAY_VALUE_MODE.ALERT_RATE) {
      return ivRewardPlayValue / 100
    } else {
      return ivRewardPlayValue
    }
  }

  getFilePathByRemoteUrlForRvIv(resParam = { url: '', type: 2 }) {
    return new Promise(resolve=>{
      super.getFilePathByRemoteUrlForRvIv(resParam).then((ret) => {
        const data = {
          path: ret.path,
          path4Web: ret.path,
          decodeUrl: resParam.url,
          downloaded: resParam.url == ret.path ? 0 : 1,
        }
        resolve(data)
      })
    })
  }

  addStoreKitTo(params = {}) {
    console.warn('安卓下暂不支持storkit')
  }

  getDevMuteSetting(showData={}) {
    return new Promise((resolve) => {
      resolve(showData.playVideoMute)
    })
  }
}

export default Android